/**
 * Total factory size dropdown (Profile → Factory & Warehouse) and public storefront labels.
 * Stored values are codes (e.g. under_500); UI forms use `label`, hero/storefront use `storefrontLabel`.
 */
export const TOTAL_FACTORY_SIZE_OPTIONS = [
  { label: "Under 500 sqm", value: "under_500", storefrontLabel: "500sqm" },
  { label: "500 - 1500 sqm", value: "500_1500", storefrontLabel: "500–1500 sqm" },
  { label: "1500 sqm", value: "1500", storefrontLabel: "1500 sqm" },
  { label: "1500 - 5000 sqm", value: "1500_5000", storefrontLabel: "1500–5000 sqm" },
  { label: "Above 5000 sqm", value: "5000_plus", storefrontLabel: "5000sqm+" },
] as const;

const STOREFRONT_LABEL_BY_CODE: Record<string, string> = Object.fromEntries(
  TOTAL_FACTORY_SIZE_OPTIONS.map((o) => [o.value, o.storefrontLabel])
);

/** Map profile/storefront code to short public label; pass through unknown strings (e.g. free-text storefront). */
export function formatFactorySizeForStorefront(raw: unknown): string {
  if (raw === undefined || raw === null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  return STOREFRONT_LABEL_BY_CODE[s] ?? s;
}
